import { DeskDocument, DeskDossier } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const DossierToolkitObject =
  registerToolkitObjectType<DeskDossier>('dossier');
